import React, { forwardRef, useEffect, useState } from 'react';

import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';
import { Control } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { useListFacesPageFilters } from '../../../useListDetailsFilters';

function UserDataFilterPopover(
  {
    ...props
  }: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { t } = useTranslation();
  const [localValue, setLocalValue] = useState<string>('');
  const { filters, updateFilters, updateFiltersDebounced } = useListFacesPageFilters();

  const onChangeHandler = (user_data: string) => {
    setLocalValue(user_data);
    updateFiltersDebounced({ user_data });
  };

  useEffect(() => {
    setLocalValue(filters.user_data ?? '');
  }, [filters]);

  const reset = () => {
    updateFilters({ user_data: undefined });
  };

  return (
    <PopoverWithButton
      {...props}
      onClickReset={reset}
      ref={ref}
      title={<div className="Body-2">{t('list-details-page:filters.popovers.user_data')}</div>}
    >
      <Control.Input
        isClearable
        onChangeValue={onChangeHandler}
        onClear={reset}
        value={localValue}
      />
    </PopoverWithButton>
  );
}

const UserDataFilterPopoverWithRef = forwardRef(UserDataFilterPopover);
export { UserDataFilterPopoverWithRef as UserDataFilterPopover };
